import { ISolanaNFTState, ITrendingNFTs } from 'models'
import { orderRef, order } from 'constant'

/* ------------- Initial State ------------- */

export const SOLANA_NFT_INITIAL_STATE: ISolanaNFTState = {
  collection: [],
  loading: false,
  limit: 10,
  isRequesting: false,
  hasInitialized: false,
  hasDataToLoad: true,
  orderRef: orderRef.CREATED_AT,
  order: order.DESC,
}

export const TRENDING_NFTS_INITIAL_STATE: ITrendingNFTs = {
  active: false,
  chain: '',
  slug: '',
  name: '',
  // image_url: '',
  stats: [],
  // stats_eth: [],
}
